import React, { FunctionComponent } from 'react';

import styles from './TwitterTweetCardMedia.module.scss';
import { useModal } from 'app/context/Modal';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { TMultiMedia } from 'news/utils/types';
import DefaultVideo from '../../assets/images/defaultVideo.png';
interface Props {
  attachments: TMultiMedia[];
  isTopicCard?: boolean;
}

const TwitterTweetCardMedia: FunctionComponent<Props> = ({
  attachments,
  isTopicCard,
}) => {
  const modal = useModal();
  const handelOpenImage = (index = 0) => {
    modal.show({
      imageUrls: attachments?.map((i) => ({
        url: i.url,
        type: i.type,
      })),
      imageIndex: index,
    });
  };
  const handelOpenVideo = (index = 0) => {
    modal.show({
      imageUrls: attachments,
      imageIndex: index,
    });
  };
  //check to see if there is only video and image attachments
  const isVideoOrImage = !attachments.find(
    (item) => item.type !== 'VIDEO' && item.type !== 'IMAGE',
  );
  return (
    <div className={styles.TwitterTweetCardMedia}>
      {attachments?.length !== 0 && isVideoOrImage && (
        <div
          style={isTopicCard ? { maxWidth: '350px' } : {}}
          className={`${styles.tweetCardContainer}`}
        >
          {attachments?.length === 1 && (
            <div
              onClick={() => {
                !attachments?.[0]?.thumbnail
                  ? handelOpenImage()
                  : handelOpenVideo();
              }}
              className={`${styles.tweetImageUrl}`}
            >
              <img
                src={
                  attachments?.[0]?.type === 'VIDEO'
                    ? !attachments?.[0]?.thumbnail
                      ? DefaultVideo
                      : attachments?.[0]?.thumbnail
                    : attachments?.[0]?.url
                }
                alt="image"
              />
              {attachments?.[0]?.thumbnail && (
                <button className={styles.VideoBtn}>
                  <PlayArrowIcon />
                </button>
              )}
            </div>
          )}
          {attachments?.length >= 2 && (
            <div
              className={`${styles.TwitterTweetCardMedia_ImageGrid} ${
                attachments?.length === 3
                  ? styles.TwitterTweetCardMedia_ImageGrid_three_items
                  : ''
              }`}
            >
              {attachments?.map((item: Record<string, any>, index: number) =>
                item?.type !== 'VIDEO' ? (
                  <img
                    src={item?.url}
                    alt="image"
                    key={item?.url}
                    onClick={() => {
                      handelOpenImage(index);
                    }}
                  />
                ) : (
                  <div
                    className={`${styles.tweetImageUrl}`}
                    onClick={() => handelOpenVideo()}
                  >
                    <img
                      src={item.thumbnail || DefaultVideo}
                      alt=" image alt"
                    />
                    {item?.thumbnail && (
                      <button className={styles.VideoBtn}>
                        <PlayArrowIcon />
                      </button>
                    )}
                  </div>
                ),
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TwitterTweetCardMedia;
